import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ClaimsListComponent } from '../claims-list/claims-list.component';
import { AbstractClaimsListDirective } from '@directives/abstract-claims-list.directive';
import { map } from 'rxjs';

@Component({
  selector: 'lv-list-sessions-with-pending-retake-requests',
  templateUrl: './list-sessions-with-pending-retake-requests.component.html',
  styleUrls: ['./list-sessions-with-pending-retake-requests.component.scss'],
  imports: [CommonModule, TranslateModule, ClaimsListComponent]
})
export class ListSessionsWithPendingRetakeRequestsComponent extends AbstractClaimsListDirective {
  sessions$ = this.sessionsService.pendingRetakeSessions().pipe(map((sessions) => this.filterMySessions(sessions)));
}
